export const FETCH_PUBLICEXPOSUREASSETS_BEGIN="FETCH_PUBLICEXPOSUREASSETS_BEGIN";
export const FETCH_PUBLICEXPOSUREASSETS_SUCCESS="FETCH_PUBLICEXPOSUREASSETS_SUCCESS";
export const FETCH_PUBLICEXPOSUREASSETS_FAILURE="FETCH_PUBLICEXPOSUREASSETS_FAILURE";

export const FETCH_PUBLICEXPOSUREMINMAXDATES_BEGIN="FETCH_PUBLICEXPOSUREMINMAXDATES_BEGIN";
export const FETCH_PUBLICEXPOSUREMINMAXDATES_SUCCESS="FETCH_PUBLICEXPOSUREMINMAXDATES_SUCCESS";
export const FETCH_PUBLICEXPOSUREMINMAXDATES_FAILURE="FETCH_PUBLICEXPOSUREMINMAXDATES_FAILURE";

export const FETCH_PUBLICEXPOSUREOVERLAPANALYSISREPORTDATA_BEGIN="FETCH_PUBLICEXPOSUREOVERLAPANALYSISREPORTDATA_BEGIN";
export const FETCH_PUBLICEXPOSUREOVERLAPANALYSISREPORTDATA_SUCCESS="FETCH_PUBLICEXPOSUREOVERLAPANALYSISREPORTDATA_SUCCESS";
export const FETCH_PUBLICEXPOSUREOVERLAPANALYSISREPORTDATA_FAILURE = "FETCH_PUBLICEXPOSUREOVERLAPANALYSISREPORTDATA_FAILURE";

export const FETCH_PUBLICEXPOSURETSCHART_BEGIN = "FETCH_PUBLICEXPOSURETSCHART_BEGIN";
export const FETCH_PUBLICEXPOSUREEQUITYCHART_SUCCESS = "FETCH_PUBLICEXPOSUREEQUITYCHART_SUCCESS";
export const FETCH_PUBLICEXPOSURECURRENTSECTORCHART_SUCCESS = "FETCH_PUBLICEXPOSURECURRENTSECTORCHART_SUCCESS";
export const FETCH_PUBLICEXPOSURESECTORNOOPCHART_SUCCESS = "FETCH_PUBLICEXPOSURESECTORNOOPCHART_SUCCESS";
export const FETCH_PUBLICEXPOSURESECTORCHART_SUCCESS = "FETCH_PUBLICEXPOSURESECTORCHART_SUCCESS";
export const FETCH_PUBLICEXPOSURETSCHART_FAILURE = "FETCH_PUBLICEXPOSURETSCHART_FAILURE";


export const FETCH_GETOVERLAPASSET_BEGIN = "FETCH_GETOVERLAPASSET_BEGIN";
export const FETCH_GETOVERLAPASSET_SUCCESS = "FETCH_GETOVERLAPASSET_SUCCESS";
export const FETCH_GETOVERLAPASSET_FAILURE = "FETCH_GETOVERLAPASSET_FAILURE";


   